var _excluded = ["id", "content"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styles from '../../Tabs.scss.js';
import { Item } from '../Item/Item.js';
function List(_ref) {
  var focusIndex = _ref.focusIndex,
    disclosureTabs = _ref.disclosureTabs,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    _ref$onKeyPress = _ref.onKeyPress,
    onKeyPress = _ref$onKeyPress === void 0 ? noop : _ref$onKeyPress;
  var tabs = disclosureTabs.map(function (_ref2, index) {
    var id = _ref2.id,
      content = _ref2.content,
      tabProps = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(Item, Object.assign({
      key: id
    }, tabProps, {
      id: id,
      focused: index === focusIndex,
      onClick: onClick.bind(null, id)
    }), content);
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: styles.List,
    onKeyDown: handleKeyDown,
    onKeyUp: onKeyPress
  }, tabs);
}
function noop() {}
function handleKeyDown(event) {
  var key = event.key;
  if (key === 'ArrowLeft' || key === 'ArrowRight') {
    event.preventDefault();
    event.stopPropagation();
  }
}
export { List };